export default __webpack_public_path__ + "static/media/Employee Management.bd6612d9.png";